import { arrayMove } from '@dnd-kit/sortable';

export const sortByAlpha = (arr, key) =>
  arr.sort((a, b) => a[key].toLowerCase().localeCompare(b[key].toLowerCase()));

export const sortable = (arr) => arr.sort((a, b) => a.sort - b.sort);

export const dragSort = (collection, active, over) => {
  const oldIndex = collection.map((model) => model.id).indexOf(active.id);
  const newIndex = collection.map((model) => model.id).indexOf(over.id);
  const newPositions = arrayMove(collection, oldIndex, newIndex);
  return newPositions.map((model, i) => ({ ...model, sort: i }));
};

export const adjustSortablesAfterDelete = (collection, destroyedID) => {
  // match the new sort values handled by separate backend process
  let sortValue = collection.find((model) => model.id == destroyedID).sort;
  let adjusted = collection.filter((model) => model.id != destroyedID);
  adjusted.forEach((o) => {
    if (o.sort > sortValue) o.sort -= 1;
  });
  return [...adjusted];
};
